import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'RugCardContainer'

    static propTypes = {
      enablePreview: PropTypes.bool,
      fixedHeight: PropTypes.bool,
      fromPage: PropTypes.string,
      index: PropTypes.number,
      noRibbon: PropTypes.bool,
      rug: PropTypes.object.isRequired,
      setCurrentIndex: PropTypes.func,
      togglePreview: PropTypes.func,
      user: PropTypes.object.isRequired,
      userPermissions: PropTypes.array.isRequired,
    }

    static defaultProps = {
      enablePreview: false,
      fixedHeight: false,
      fromPage: '',
      noRibbon: false,
    }

    handleTogglePreview = () => {
      const { index, setCurrentIndex, togglePreview } = this.props

      setCurrentIndex(index)
      togglePreview()
    }

    render() {
      return <WrappedComponent handleTogglePreview={this.handleTogglePreview} {...this.props} />
    }
  }

  return Container
}
